import $ from 'jquery';

import smileyService from '../../Services/smiley';
const smileyServicesBridge = $.extend({}, smileyService);

smileyServicesBridge.smilize = function (elements, postProcess) {
    smileyService.smilize(elements);

    $(elements).each(function (elmN, element) {
        $('img.smilies', element).each(function (n, img) {
            var $img = $(img);
            if (typeof postProcess === 'function' && !$img.data('smileyProcessed')) {
                postProcess(img, img.alt);
                $img.data('smileyProcessed', true);
            }
        });
    });
};

window._define('bridge/smiley', smileyServicesBridge);
